import { createSelector } from 'reselect'

import { getClientIdFromToken } from 'src/auth'
import { selectClientId } from 'store/selectors/client'

export const selectAuthedAsClient = createSelector(
  selectClientId,
  clientId => getClientIdFromToken() === clientId
)
